// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPlayer_root_24k4d","video":"VideoPlayer_video_ct2FC"};